import { Flex } from '@chakra-ui/react';
import { CustomerNavigationContext } from '@bridge/navigationStore';
import { useTranslation } from 'react-i18next';
import { ClassicalBreadcrumb } from './ClassicalBreadcrumb';
import { ContextNavigationItem } from './ContextNavigationItem';
import { ContextUtilityLinks } from './ContextUtilityLinks';
import { CurrentContextHeader } from './CurrentContextHeader';
import {
  customerItems,
  customerUtilityItems,
  isStateActive,
} from './navigationItems';

interface CustomerContextNavigationProps {
  activeState: string;
  context: CustomerNavigationContext;
}

export function CustomerContextNavigation({
  activeState,
  context,
}: CustomerContextNavigationProps) {
  const { t } = useTranslation();
  const params = { customerId: context.customer.id };
  const translateLabel = (label: string) => t(label as 'navigation.articles');

  return (
    <>
      <ClassicalBreadcrumb
        items={[
          {
            label: t('navigation.brands'),
            route: 'customerDirectory',
            navobj: {},
          },
          { label: context.customer.name },
        ]}
      />
      <CurrentContextHeader
        archived={context.customer.archived}
        label={t('navigation.customer')}
        title={context.customer.name}
      />
      <ContextUtilityLinks
        activeState={activeState}
        items={customerUtilityItems}
        navobj={params}
      />
      <Flex direction="column" pt={3}>
        {customerItems.map((item) => (
          <ContextNavigationItem
            key={item.route}
            label={translateLabel(item.label)}
            route={item.route}
            navobj={params}
            active={isStateActive(activeState, item.route)}
          />
        ))}
      </Flex>
    </>
  );
}
